export const plans1 = [
	// {
	// 	title: 'Entrenamiento Personaje Tigre',
	// 	descrition: '',
	// 	price: '$499 USD',
	// 	priceBefore: '$699 USD',
	// 	urls: {
	// 		ninguno: 'https://checkout.bold.co/payment/LNK_Q1LIBXISB3',
	// 		internacional: 'https://checkout.wompi.co/shipping',
	// 	},
	// 	temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
	// 	items: [
	// 		{
	// 			title: 'Personaje Tigre.',
	// 		},
	// 		{
	// 			title: 'A tu ritmo.',
	// 		},
	// 		{
	// 			title: 'Certificado Libel.',
	// 		},
	// 		{
	// 			title: 'Acceso 1 año.',
	// 		},
	// 	],
	// 	center: true,
	// 	top: false,
	// 	ball: true,
	// 	promo: '30% DTO',
	// 	type: 'presencial',
	// },
	{
		title: 'Entrenamiento Full Premium',
		descrition: '',
		price: '$999 USD',
		priceBefore: '$1.099 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_G12M235PFL',
			internacional: 'https://checkout.bold.co/payment/LNK_G12M235PFL',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Material premium.',
			},
			{
				title: 'A tu ritmo.',
			},
			{
				title: 'Certificado Libel.',
			},
			{
				title: 'Acceso 1 año.',
			},
		],
		center: true,
		top: true,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
